import * as React from 'react';
import { historyContext } from './context';
export var HistoryProvider = function (props) {
    var history = props.history, children = props.children;
    return (React.createElement(historyContext.Provider, { value: history }, children));
};
